/**
 * Beneficial owner confirmation replacer
 */

define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var user = require('user');
    var formatter = require('common/formatter');
    var BaseReplacerView = require('common/base.replacer.view');
    var PopupView = require('modules/popup/popup.view');
    var BeneficialOwnerModel = require('replacers/beneficial-owner/beneficial-owner.model');
    var AcceptDeclinePopupView = require('modules/popup/swiss-theme/accept-decline.popup.view');

    module.exports = BaseReplacerView.extend({

        model: new BeneficialOwnerModel(),

        tagName: 'span',

        className: 'beneficial_owner',

        accessRules: {
            allow: ['user']
        },

        events: {
            'tap .fn-beneficial-confirm': 'submitConfirm'
        },

        initialize: function() {
             this.getTag();
        },

        getTag: function() {
            var tagName = 'sc/verification/beneficialAccountConfirmation';
            return user.getPlayerTags(tagName)
                .done(this.onSuccessGetTag.bind(this))
                .fail(console.error);
        },

        onSuccessGetTag: function(response) {
            if (response.data.tags && response.data.tags.length > 0) {
                var tag = response.data.tags[0];
                if(tag.value === 'optional') {
                    this.model.set('tagValue', 'optional');
                } else {
                    this.model.set('tagValue', 'approved');
                }
            } else {
                this.model.set('beneficialEl', 'hidden');
            }
        },

        formatDate: function(dateString) {
            var date = dateString.replace(' ', 'T');

            return formatter.getDate(new Date(date)).split('-').reverse().join('.');
        },

        render: function() {
            this.model.fetch()
                .done(this.renderDone.bind(this))
                .fail(this.renderFail.bind(this));
            return this;
        },

        renderDone: function(response) {
            var date = response.data.userPaymentsInfoData.lastBeneficialOwnerConfirmDate || '';
            var formatDate = this.formatDate(date);
            this.$el.html(this.tmpl('beneficial-owner', { lastDate: formatDate }));
            var tagValue = this.model.get('tagValue');
            var beneficialEl = this.model.get('beneficialEl');

            if (tagValue === 'optional') {
                $('#confirm').removeClass('hidden');
                $('#beneficialEl').removeClass('hidden');
            } else {
                $('#confirm').addClass('hidden');
                $('.verified').removeClass('hidden');
            }

            if (beneficialEl === 'hidden') {
                $('#beneficialEl').addClass('hidden');
            }
        },

        renderFail: function() {
            this.$el.html(this.tmpl('beneficial-owner', { lastDate: '' }));
        },

        submitConfirm: function(e) {
            e.preventDefault();
            var userDetails = user.get('userDetails');

            new AcceptDeclinePopupView({
                data: {
                    title: this.translate('playtech.mobile.system.beneficialOwner.confirmInfo'),
                    content: this.tmpl('beneficial-owner-popup', {
                        firstName: userDetails.firstName || '',
                        lastName: userDetails.lastName || '',
                        streetName: userDetails.addressDetails.streetName || '',
                        buildingNumber: userDetails.addressDetails.buildingNumber || '',
                        countryCode: userDetails.countryCode || '',
                        zip: userDetails.zip || '',
                        city: userDetails.city || ''
                    })
                },
                onAccept: function() {
                    this.model.setConfirmDate()
                        .then(this.model.setTag.bind(this))
                        .then(this.model.getConfirmDate.bind(this))
                        .done(this.onSuccessAccept.bind(this))
                        .fail(this.failedRequest.bind(this));
                    this.render();
                }.bind(this)
            });
        },

        onSuccessAccept: function(response) {
            var date = response.data.userPaymentsInfoData.lastBeneficialOwnerConfirmDate;
            if (date) {
                var formatDate = this.formatDate(date);
                $('#confirm').css('display', 'none');
                $('.verified').removeClass('hidden');
                $('.date').html(', ' + formatDate);
            }
        },

        failedRequest: function(response) {
            new PopupView({
                data: {
                    title: response.data.errorCode,
                    content: response.data.errorMessage
                }
            });
        }
    }, {
        nameOfReplacers: [
            'BENEFICIAL_OWNER'
        ]
    });
});
